import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/features';
import { downloadLinks } from '@/mocks/about';
import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-800 text-sm font-medium rounded-full mb-4">
              <i className="ri-question-answer-line mr-1"></i>
              常见问题
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
              有疑问？这里都有答案
            </h2>
            <p className="text-foreground-500 text-base mb-8">
              找不到您想要的答案？欢迎查看我们的详细帮助中心或联系客服。
            </p>

            <Link
              to="/article/aiye-video-app-changjian-wenti"
              className="inline-flex items-center gap-2 px-6 py-2.5 border border-background-300 rounded-full text-foreground-600 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-all duration-300 cursor-pointer"
            >
              查看完整FAQ
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.slice(0, 5).map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-xl overflow-hidden cursor-pointer"
              >
                <button
                  className="w-full flex items-center justify-between p-5 text-left"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="text-foreground-900 font-medium text-sm pr-4">
                    {faq.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    openIndex === index ? 'max-h-48 pb-5 px-5' : 'max-h-0'
                  }`}
                >
                  <p className="text-foreground-500 text-sm leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}